<app-modal-basic #createCustomInvoiceModal [dialogClass]="'modal-md'">
  <div class="app-modal-header">
    <h4 class="modal-title" *ngIf="!isCreditInvoice && !customInvoice">
      {{'admin.order.custom_invoice.modal.title'| translate }}
    </h4>
    <h4 class="modal-title" *ngIf="!isCreditInvoice && customInvoice">
      {{'admin.dealer.order.custom_invoice_edit.modal.title'| translate }}
    </h4>
    <h4 class="modal-title" *ngIf="isCreditInvoice">
      {{'admin.backoffice.invoice.credit-invoice.edit-modal-title'| translate }}
    </h4>
    <button type="button" class="close basic-close" (click)="hideCustomInvoiceModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #addCreateCustomInvoiceForm="ngForm">
      <div *ngIf="isCreditInvoice">
         {{'admin.backoffice.invoice.credit-invoice.are-you-sure'| translate:{invoicenumber: originalInvoiceId} }}
      </div>
      <div *ngIf="!hideDeliveryDealer && !isCreditInvoice">
        <p>{{'admin.order.custom_invoice.modal.choose-dealer' | translate}}</p>
        <div class="form-group row">

          <div class="form-group form-default form-static-label col-12">
            <ng-select required name="dealer" id="dealer" [items]="dealers$" bindLabel="companyName" bindValue="id"
                       (change)="dealerChange($event)"
                       [(ngModel)]="selectedDealer" [clearable]="false"
                       autofocus [typeahead]="dealerTypeHead"></ng-select>
          </div>
        </div>
      </div>

      <div >
        <p>{{'admin.order.custom_invoice.modal.choose-layout' | translate}}</p>
        <div class="form-group row">
          <div class="form-group form-default form-static-label col-12">
            <ng-select required name="type"  [items]="templatesModalCustomInvoice" bindLabel="label" bindValue="value"
                       [(ngModel)]="selectedTemplateModalCustomInvoice" [clearable]="false" [searchable]="false"></ng-select>
          </div>
        </div>
      </div>


      <p>{{'admin.order.custom_invoice.modal.invoice-item'|translate }}</p>
      <hr class="mb-4">

      <ng-container *ngFor="let creatCustomInvoiceItem of createCustomInvoiceItems; let i = index">
        <div class="form-row row px-2">
          <div class="form-group col-md-6 px-1">
            <label [for]="'description' + i">{{"doctrine.backoffice.credit-invoice.description" | translate}}<span
              class="star">*</span></label>
            <input required [name]="'description' + i"
                   [id]="'description' + i"
                   class="form-control"
                   #description="ngModel"
                   [(ngModel)]="creatCustomInvoiceItem.description">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="description.invalid && description.dirty && description.errors?.required">
              {{'errors.required'|translate}}
            </div>
          </div>
          <div class="form-group col-md-3 px-1">
            <label [for]="'amount' + i">{{"doctrine.backoffice.credit-invoice.amount" | translate}}   <span
              class="star">*</span></label>
            <input required [name]="'amount' + i"
                   type="number"
                   step="1"
                   min="1"
                   [id]="'amount' + i"
                   class="form-control"
                   #amount="ngModel"
                   [(ngModel)]="creatCustomInvoiceItem.amount">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="amount.invalid && amount.dirty && amount.errors?.required">
              {{'errors.required'|translate}}
            </div>
            <div class="messages text-danger"
                 *ngIf="amount.errors?.min">
              {{'errors.positive_rang'|translate }}
            </div>
          </div>
          <div class="form-group col-md-3 px-1">
            <label [for]="'price' + i">
              <span>
                {{"doctrine.backoffice.credit-invoice.price" | translate}}
              </span>
              <span
              class="star">*</span></label>
            <input required [name]="'price' + i"
                   type="number"
                   step="0.01"
                   min="1"
                   [id]="'price' + i"
                   class="form-control"
                   #price="ngModel"
                   [(ngModel)]="creatCustomInvoiceItem.price">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="price.invalid && price.dirty && price.errors?.required">
              {{'errors.required'|translate}}
            </div>
            <div class="messages text-danger"
                 *ngIf="price.errors?.min">
              {{'errors.positive_rang'|translate }}
            </div>
          </div>
          <div class="form-group col-md-1 px-1" *ngIf="i !== 0">
            <a class="btn btn-lg btn-icon ripple light ms-1" (click)="removeCustomInvoiceItem(i)">
              <i class="fa fa-trash trash-danger"></i>
            </a>
          </div>
        </div>
      </ng-container>
      <button class="btn btn-primary ripple light mb-0 mt-0" (click)="addCustomInvoiceItem()">
        <i class="fa fa-plus fa-fw "></i>
        &nbsp;{{'global.add' | translate}}
      </button>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="hideCustomInvoiceModal()">{{'global.cancel'|translate}}</button>
    <button type="submit" class="btn btn-primary ripple light" (click)="createCustomInvoice()"
            [disabled]="!addCreateCustomInvoiceForm.valid || disableCreateCustomInvoiceBtn">
      {{ 'admin.order.custom_invoice.modal.confirm' | translate}}
    </button>
  </div>
</app-modal-basic>
<app-modal-basic #addressModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.customer_address'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="closeAddressModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body"  id="address-confirmation">
    <p class="model-text">{{ 'admin.customer_address.description'|translate}}</p>
    <div class="container">
      <form #addressForm="ngForm" action="javascript:">
        <div *ngIf="isCustomerAccount" class="form-row row">
          <div class="form-group col-md-6">
            <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.full_name'|translate}}<span class="star">*</span>
                 </span>
            </label>
            <div>
              <input type="text" class="form-control" name="addressFullName" #addressFullName="ngModel" [(ngModel)]="customerDetail.fullName" autofocus required>
            </div>
          </div>
          <div class="form-group col-md-6">
            <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.phone_number'|translate}}<span class="star">*</span>
                 </span>
            </label>
            <div>
              <input type="text" class="form-control" name="addressPhoneNumber" #addressPhoneNumber="ngModel" [(ngModel)]="customerDetail.phoneNumber" autofocus required>
            </div>
          </div>
          <div class="form-group col-md-6">
            <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.email'|translate}}<span class="star">*</span>
                 </span>
            </label>
            <div>
              <input type="email" class="form-control" name="addressEmail" #addressEmail="ngModel" [(ngModel)]="customerDetail.email" autofocus email required>
            </div>
          </div>
          <div class="form-group col-md-6"></div>
          <div class="form-group col-md-6">
            <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.street'|translate}}<span class="star">*</span>
                 </span>
            </label>
            <div>
              <input type="text" class="form-control" name="addressStreet" #addressStreet="ngModel" [(ngModel)]="customerDetail.street" autofocus required>
            </div>
          </div>
          <div class="form-group col-md-6">
            <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.house_number'|translate}}<span class="star">*</span>
                 </span>
            </label>
            <div>
              <input type="text" class="form-control" name="addressHouseNumber" #addressHouseNumber="ngModel" [(ngModel)]="customerDetail.houseNumber" autofocus required>
            </div>
          </div>
          <div class="form-group col-md-6">
            <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.zip_code'|translate}}<span class="star">*</span>
                 </span>
            </label>
            <div>
              <input type="text" class="form-control" name="addressZipCode" #addressZipCode="ngModel" [(ngModel)]="customerDetail.zipCode" autofocus required>
            </div>
          </div>
          <div class="form-group col-md-6">
            <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.city'|translate}}<span class="star">*</span>
                 </span>
            </label>
            <div>
              <input type="text" class="form-control" name="addressCity" #addressCity="ngModel" [(ngModel)]="customerDetail.city" autofocus required>
            </div>
          </div>
          <div class="form-group col-md-6">
            <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.country'|translate}}<span class="star">*</span>
                 </span>
            </label>
            <div>
              <input type="text" class="form-control" name="addressCountry" #addressCountry="ngModel" [(ngModel)]="customerDetail.country" autofocus required>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple me-2 ripple"
            (click)="closeAddressModal()">{{'global.cancel'|translate}}</button>
    <button type="button" (click)="createCustomInvoice()" [disabled]="!addressForm.valid" class="btn btn-primary ripple light">{{'global.confirm_address'|translate}}</button>
  </div>
</app-modal-basic>

